<template>
  <div>
    <g-master name="nivelCompetencia"
              :endpoint="lvlComMaster.endpoint"
              :tableSetup="lvlComMaster.tableSetup"
              :modalFieldsSetup="lvlComMaster.modalFieldsSetup"
              :parentData="parentData"
              :beforeSend="lvlComMaster.beforeSend">
      <template slot="masterModal" slot-scope="{record}">
        <a-form-item v-bind="fiOptions" label="Descripción: " :has-feedback="false">
          <a-input
            v-decorator="['description', { rules: [{ required: true, message: 'Valor requerido'}] }]"/>
        </a-form-item>
      </template>
    </g-master>
    <a-tabs default-active-key="1">
      <a-tab-pane tab="NIVEL DEL CARGO" key="1">
        <level-c-job v-if="idLevel" :id_level="idLevel"></level-c-job>
        <span v-else>Seleccione un nivel de evaluación para ver más.</span>
      </a-tab-pane>
    </a-tabs>
  </div>
</template>


<script>
  export default {
    data () {
      return {
        visible: false,
        colComOptions: {xs: 24, sm: 24},
        fiOptions: {
          'label-col': {span: 8},
          'wrapper-col': {span: 16},
          'has-feedback': true
        },
        lvlComMaster: {
          beforeSend: (data) => {
            data.id_evaluation = this.id_evaluation
            return data
          },
          actions: {
            actions: [
              {
                name: 'masterEdit',
                text: 'Editar',
                permisos: [],
                props: {size: 'small', type: 'link', icon: 'edit'}
              },
              {
                name: 'masterDelete',
                text: 'Eliminar',
                permisos: [],
                props: {size: 'small', icon: 'delete', type: 'link'}
              }
            ]
          },
          endpoint: 'level_competency',
          tableSetup: {
            allowSelect: true,
            selectedRows: [],
            tableConfig: {
              rowKey: 'id_level'
            },
            columns: [
              {title: 'Descripción', dataIndex: 'description', sorter: true}
            ]
          },
          modalFieldsSetup: [
            {name: 'description'},
            {name: 'id_evaluation'}
          ]
        }
      }
    },
    props: ['id_evaluation'],
    computed: {
      parentData () {
        return {
          id_evaluation: this.id_evaluation
        }
      },
      idLevel () {
        return this.lvlComMaster.tableSetup.selectedRows.length > 0 ? this.lvlComMaster.tableSetup.selectedRows[0].id_level : null
      }
    }
  }
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// src/customization/GlobalBPOCore/pages/Mantenimiento/Evaluaciones/NivelCompetencia.vue